export enum Locale {
  EN_COM = 'en_com',
  DE_CH = 'de_ch',
}

export enum LocaleHreflang {
  EN_COM = 'en',
  EN_US = 'en-US',
  DE_CH = 'de-CH',
}

export enum Language {
  EN = 'en',
  DE = 'de',
}

export enum MarketLocale {
  COM = 'com',
  US = 'us',
  CH = 'ch',
}

export const LOCALE_TO_MARKET_LOCALE_MAP: Record<Locale, MarketLocale> = {
  [Locale.EN_COM]: MarketLocale.COM,
  [Locale.DE_CH]: MarketLocale.CH,
};

export const LOCALE_TO_LANGUAGE_MAP: Record<Locale, Language> = {
  [Locale.EN_COM]: Language.EN,
  [Locale.DE_CH]: Language.DE,
};

export const LANGUAGE_TO_TRANSLATIONS_MAP: Record<Language, string> = {
  [Language.EN]: 'English',
  [Language.DE]: 'Deutsch',
};

export const LOCALE_TO_HREFLANG_MAP: Record<Locale, LocaleHreflang> = {
  [Locale.DE_CH]: LocaleHreflang.DE_CH,
  [Locale.EN_COM]: LocaleHreflang.EN_COM,
};

export const MARKET_TO_TRANSLATIONS_MAP: Record<MarketLocale, string> = {
  [MarketLocale.COM]: 'International',
  [MarketLocale.US]: 'United States',
  [MarketLocale.CH]: 'Switzerland',
};
